<template>
  <div>
    <div style="display:flex" v-if="!isPreview" >
      <div class="input-box">
        <span class="d-text">{{ showFileText }}</span>
        <span class="chip-sm" @click="onfile">檔案</span>
        <span class="chip-sm" @click="onResetfile">x</span>
        <input type="file"
               accept=".pdf,image/*"
               style="display: none;"
               ref="filePicker"
               @change="onFileSelection" v-if="showFile">
      </div>
      <v-btn color="secondary" class="upload-item" @click="onUploadFile" v-if="!isPreview">上傳</v-btn>
    </div>
    <slot></slot>
    <sub-title v-if="files !== []" class="mt-default" style="color:#a0a0a0">已上傳檔案
      <span class="strong"> (要檢視瀏覽已上傳檔案請直接點下方檔名即可)</span>
    </sub-title>
    <div class="files">
      <div v-for="(file,index) in files"
          :key="index"
          class="mt-2">
        <label  class=" link-finger underline" @click="loadShowFileIdx(index)">{{ file.name }}</label>
        <button @click="removeFile(index)" class="ml-2 close" v-if="!isPreview" >
          x
        </button>
        <base-dialog-full title="上傳檔案檢視"
                          :show="showfileIdx==index"
                          :tempSaveBtn="false"
                          @close="closeShowFileIdx(index)">
          <img :src="getImgSrc(file)" width="50%" v-if="file.name.indexOf('.pdf') == -1" />
          <v-layout v-scroll:#collective-Statement="onScroll" v-if="file.name.indexOf('.pdf') != -1" >
            <pdf-viewer :base64Data="getPdfSrc(file)" />
          </v-layout>
        </base-dialog-full>
      </div>
    </div>
  </div>
</template>
<script>
import pdfViewer from '@/components/PDFViewer/PDFViewer.vue'
export default {
  name: 'upload-input',
  components: { pdfViewer },
  props: {
    fileType: String,
    filesUpd: {
      type: Array
    },
    isPreview: Boolean
  },
  data () {
    return {
      files: [],
      input: null,
      showFile: true,
      defShowFileText: '請選擇檔案或拍照上傳',
      showFileText: '請選擇檔案或拍照上傳',
      tmpFile: {},
      showfileIdx: Number,
      acceptedJPGTypes: ['image/jpg', 'image/jpeg'],
      acceptedImageTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      acceptedPdfTypes: ['application/pdf'],
    }
  },
  watch: {
    filesUpd: {
      handler (filesUpd) {
        this.files = filesUpd
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onfile () {
      this.$emit('file-picker')
      const event = new MouseEvent('click')
      this.$refs.filePicker.dispatchEvent(event)
    },
    onResetfile () {
      this.onResetSelectFile()
      this.onClearFile()
      // update hasTmpFile
      this.onUpdChgTmpFile(false)
      this.tmpFile = null
    },
    onFileSelection (e) {
      const { acceptedJPGTypes, acceptedImageTypes, acceptedPdfTypes } = this
      const maxFileByte = 5242880
      const maxFileName = 40
      this.onResetSelectFile()
      this.onClearFile()
      // add all selected files
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return false
      this.tmpFile = {}
      for (let file of files) {
        let fileCntType = file['type']
        let name = file['name']
        // 檔案類型判斷
        if (this.fileType === 'A') {
          if (!acceptedJPGTypes.includes(fileCntType)) { // 行動投保同意書需卡控只能上傳JPG
            this.$alert('檔案格式需為JPG，請重新上傳!')
            return false
          }
        } else if (!acceptedImageTypes.includes(fileCntType) && !acceptedPdfTypes.includes(fileCntType)) {
          this.$alert('檔案格式需為JPG、PNG或PDF，請重新上傳!')
          return false
        }
        // 檔案條件判斷
        if (maxFileByte < file.size) {
          this.$alert('檔案大小需5Mb以下，請重新上傳!')
          return false
        } else if(maxFileName < name.length){ //含副檔名
          this.$alert('檔案名稱超過40個字，請重新上傳!')
          return false
        } else {
          this.showFileText = file.name
          this.tmpFile = file
          // update hasTmpFile
          this.onUpdChgTmpFile(true)
        }
      }
    },
    onClearFile () {
      this.showFile = false && !this.isPreview
      this.$nextTick(() => {
        this.showFile = true && !this.isPreview
      })
    },
    onResetSelectFile () {
      this.showFileText = this.defShowFileText
    },
    getImgSrc (file) {
      let base64 = file.fileCntBase64
      return 'data:image/jpeg;base64,' + base64
    },
    getPdfSrc (file) {
      let base64 = file.fileCntBase64
      // return 'data:application/pdf;base64,' + base64
      return base64
    },
    loadShowFileIdx (idx) {
      this.showfileIdx = idx
    },
    closeShowFileIdx (idx) {
      this.showfileIdx = -1
    },

    /**
     * Removes the file with the given index
     * @param {number} index
     * @returns {void}
     */
    removeFile (index) {
      let fileDel = this.files[index]
      let fileCode = fileDel.fileCode
      if (fileCode && fileCode.length) {
        this.$emit('delete', fileDel.fileCode)
      }
      this.files.splice(index, 1)
    },
    onUploadFile () {
      if (this.tmpFile) {
        this.onGetBase64Str(this.tmpFile).then(data => {
          let updFileObj = {
            files: [this.tmpFile],
            base64Str: data,
            fileName: this.tmpFile.name,
            fileType: this.fileType
          }
          this.tmpFile = {}
          this.onResetSelectFile()
          this.$emit('upload', updFileObj)
          // update hasTmpFile
          this.onUpdChgTmpFile(false)
        })
      }
    },
    onGetBase64Str (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    onUpdChgTmpFile (hasTmpFile) {
      let hasTmpFileObj = {
        hasTmpFile: hasTmpFile,
        fileType: this.fileType
      }
      this.$emit('chg-has-tmp', hasTmpFileObj)
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    }
  }
}
</script>
<style lang="stylus" scoped>

.input-box {
  height: 40px;
  border: solid 1px #d2d2d2;
  border-radius: 5px;
  width: 300px;
  text-align: right;
}
.upload-item
  height 30px!important
  min-width: 80px !important

.chip-sm {
  padding: 0px 10px;
  margin: 5px;
  margin-top: 8px;
  display: inline-block;
  border-radius: 50px;
  border: solid 1px #a0a0a0;
  cursor pointer
}
.chip-sm:hover
  background-color #f5f5f5

.d-text {
  float: left;
  margin-top: 9px;
  margin-left: 10px;
  color: $info-color-content;
}
.close{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: $font-size-md
  font-weight: bolder;
  color:#666666;
  background: #e0e0e0;
  vertical-align: initial;
}
.files
  label
    color:#141414

.link-finger {
  cursor: pointer;
}

.strong {
  font-weight: bold;
  color:#141414
}
</style>
